/* eslint-disable */
import React, {useEffect, useState} from "react";
import {Button, Checkbox, Divider, Form, Input, message, Modal} from "antd";
import {useAuth} from "../../providers/AuthProvider";
import {userLogin} from "../../services/user";
import {useNavigate} from "react-router-dom";
import {md5} from "js-md5";
import {GoogleOutlined, MobileOutlined, WechatOutlined} from "@ant-design/icons";
import "./index.css";
import {baseAuthURL, baseURL} from "../../api/Request";
import {useTranslation} from "react-i18next";
import {GetTokenApi, getUserApi} from "../../api/Api";
// import "../../wxLogin.js";
import logo from "../../static/cn_logo2.png";
import {GoogleOAuthProvider, GoogleLogin, CredentialResponse, useGoogleLogin} from "@react-oauth/google";


function LoginPage() {
	const {setNewToken} = useAuth();
	const navigate = useNavigate();
	const {t, i18n} = useTranslation();
	const [codeVisible, setCodeVisible] = useState<boolean>(false);
	const [code, setCode] = useState<string>("");

	const msgReceive = (event: MessageEvent) => {
		// 监测是否是安全iframe
		if (!event.isTrusted) {
			return;
		}
		console.log("iframeiframeiframeiframeiframeiframe", event.data); // 获取iframe中传来的数据, 进一步进行逻辑处理
		if (typeof event.data == "string") {
			setCode(event.data);
			setCodeVisible(false);
		}
	};

	const getUserData = async () => {
		getUserApi()
			.then((res: object) => {
				localStorage.setItem("user", JSON.stringify(res));
				navigate("/d5data");
			})
			.catch((e: Error) => {
				// toast.error("Failed to get user info");
				console.log(e.message);
			});
	};
	const getToken = async (code: any) => {
		try {
			const res = (await GetTokenApi({code: code})) as any;

			if (res?.token) {
				setNewToken(res?.token);
				localStorage.setItem("token", res?.token);
				getUserData();
			}
		} catch (e) {
			console.log(e);
		}
	};

	useEffect(() => {
		if (code != "") {
			getToken(code);
		}
	}, [code]);

	useEffect(() => {
		// 组件挂载时添加事件监听
		window.addEventListener("message", msgReceive, false);

		// 组件卸载时移除事件监听
		return () => {
			window.removeEventListener("message", msgReceive);
		};
	}, []); // 空数组表示只在组件挂载和卸载时执行

	const getCode = () => {
		const wx = window.WxLogin({
			self_redirect: true,
			id: "login_container",
			appid: "wx364517dcab5ed436",
			scope: "snsapi_login",
			redirect_uri: encodeURI(
				"https://staging.chat.d5data.tech/oauth2/wechatredirect"
			),
			state: "",
			style: "white",
			href: "",
		});
	};

	useEffect(() => {
		if (codeVisible) {
			getCode();
		}
	}, [codeVisible]);

	const handleSubmit = async (values: any) => {
		try {
			const res = await userLogin({
				emailOrPhoneNumber: values?.username,
				password: md5(values?.password),
			});
			if (res) {
				message.success("Account login successful.");
				setNewToken(res.accessToken);
				localStorage.setItem("token", res.accessToken);
				navigate("/d5data");
			}
		} catch (e: any) {
			message.error("Account login failed.");
			console.log(e);
		}
	};


	const onFinishFailed = (errorInfo: any) => {
		console.log("Failed:", errorInfo);
	};

	const GoogleLoginBtn = () => {
		const API_BASE_URL = baseAuthURL;
		const loginA =
			API_BASE_URL +
			"/oauth2/authorize/google?redirect_uri=" +
			process.env.REACT_APP_OAUTH2_REDIRECT_URL;
		window.location.href = loginA;
	};

	const handleOk = () => {
		setCodeVisible(false);
	};

	const handleCancel = () => {
		setCodeVisible(false);
	};

	const handleIconClick = () => {
		if (i18n.language == "en") {
			GoogleLoginBtn();
		} else {
			setCodeVisible(true);
		}
	};

// @ts-ignore
// @ts-ignore
	return (
			<div className="login-wrapper">
				{/* <div id="login_container"></div> */}

				<Modal
					// title="Basic Modal"
					open={codeVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					<div id="login_container"></div>
				</Modal>
				<div className="glow-bg-2"></div>
				<div className="login-wrapper-main">
					<div className="header">
						<img src={logo}/>
					</div>
					<div className="login-left-wrapper">
						<div className="login-left">
							<div className="login-left-top">
								<div className="login-left-top-gradient">
									欢迎使用 点灵数据搜集平台
								</div>
								<div className="login-left-top-subtitle">
									第五维度打造的点灵数据搜集平台，是一款高效数据获取工具 <br/>
									以对话的形式，提供文本、图片等数据跨模态检索，并支持互联网公开数据和私有数据部署
									<br/>
									为AI模型训练提供高质量数据
									<br/>
								</div>
							</div>
							<div className="login-left-title-wrapper">
								<video
									width="100%"
									controls
									autoPlay
									muted
									style={{
										border: "none",
										outline: "none",
										borderRadius: "10px",
									}}
								>
									<source src="../../datagptdemo.mp4" type="video/mp4"/>
									Your browser does not support the video tag.
								</video>
							</div>
						</div>
					</div>
					<div className="dlp">
						<div className="login-card-wrapper">
							<div className="login-card-wrapper-up">
								<div className="login-card-header">
									<div className="login-card-title">输入账户和密码</div>
									<div className="login-card-subtitle">
										欢迎登录杭州五维数据有限责任公司
									</div>
								</div>
								<Form
									name="basic"
									layout="vertical"
									initialValues={{remember: true}}
									onFinish={handleSubmit}
									onFinishFailed={onFinishFailed}
									autoComplete="off"
								>
									<Form.Item
										label="邮箱或手机号"
										name="username"
										rules={[
											{required: true, message: "Please input your username!"},
										]}
									>
										<Input style={{height: "40px", width: "95%"}}/>
									</Form.Item>

									<Form.Item
										label="密码登录"
										name="password"
										rules={[
											{required: true, message: "Please input your password!"},
										]}
										style={{marginBottom: "10px"}}
									>
										<Input.Password style={{height: "40px", width: "95%"}}/>
									</Form.Item>
									<div style={{textAlign:"right",paddingRight:"25px"}}>
										<a href="/forget-password">找回密码</a>
									</div>
									<Form.Item
										label={null}
										style={{textAlign: "center", marginTop: 30}}
									>
										<Button
											type="primary"
											htmlType="submit"
											className="submit-btn"
										>
											登录
										</Button>
									</Form.Item>

									{/* <Form.Item
								name="remember"
								valuePropName="checked"
								label={null}
								style={{ marginBottom: "10px" }}
							>
								<Checkbox>记住密码</Checkbox>
							</Form.Item> */}

									<div className="login-more">
										还未注册？<a href="/signup">创建账户</a>
									</div>
									{process.env.REACT_APP_ENV !== "production_cn" && (
										<div className="login-google">
											<Divider>第三方授权登录</Divider>
											<div style={{display: "none"}}>
											</div>

											<div style={{display: "flex", justifyContent: "center", gap: "20px", alignItems: "center"}}>
												{/* Google 登录（仅当语言为英文时显示） */}
												{i18n.language === "en" && (
													<div
														className="icon-container"
														onClick={() => GoogleLoginBtn()}
														style={{fontSize: "24px", cursor: "pointer", display: "flex", alignItems: "center"}}
													>
														<GoogleOutlined/>
													</div>
												)}

												{/* 微信 和 手机号 登录（仅当语言为非英文时显示） */}
												{i18n.language !== "en" && (
													<>
														<div
															className="icon-container"
															onClick={handleIconClick}
															style={{fontSize: "24px", cursor: "pointer", display: "flex", alignItems: "center"}}
														>
															<WechatOutlined/>
														</div>
														<div
															className="icon-container"
															onClick={() => navigate("/login-by-phone")}
															style={{fontSize: "24px", cursor: "pointer", display: "flex", alignItems: "center"}}
														>
															<MobileOutlined/>
														</div>
													</>
												)}
											</div>
										</div>
									)}
								</Form>
							</div>
							<div className="login-more-confirm">
								登录即代表同意
								<a href="/docs?tab=userpolicy">《用户协议》</a>和
								<a href="/docs?tab=privacy">《产品隐私协议》</a>
							</div>
						</div>
					</div>
				</div>
			</div>
	);
}

export default LoginPage;
